import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Drawer, IconButton } from '@mui/material'
import { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { ContentInTooltip } from '../../../Components/CommonFunctions/CommonFunctions'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';

const active_status = [{ label: "All", value: "" }, { label: "Active", value: "true" }, { label: "In Active", value: "false" }]


export default function StoreCategory() {
    const history = useHistory();
    const location = useLocation();
    const [vendorList, setvendorList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [categoryName, setcategoryName] = useState('');
    const [categoryCode, setcategoryCode] = useState('');
    const [departmentName, setdepartmentName] = useState([]);
    const [filterActiveStatus, setFilterActiveStatus] = useState({ label: "All", value: "" });
    const [filterdepartmentName, setFilterdepartmentName] = useState(null);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [EditID, setEditID] = useState(null);
    const [EditListID, setEditListID] = useState(null);
    const [DeleteIds, setDeleteIds] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [departmentList, setDepartmentList] = useState([]);


    useEffect(() => {
        getCategoryDetails()
        getdepartmentList()
    }, [])

    useEffect(() => {
        if (location.states) {
            let data = location.states.line_items
            setvendorList(data)
            setEditListID(location.states.id)
            setcategoryName(location.states.pack_name)
        }
    }, []);

    const getdepartmentList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_DEPARTMENT)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setDepartmentList(response.data.data?.filter((item) => item?.is_active) || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getCategoryDetails = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(`${Serviceurls.STORE_CATEGORY}?dept_id=${filterdepartmentName ? filterdepartmentName?.id : ""}&status=${filterActiveStatus?.value}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const filData = response.data.data
                        setvendorList(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const onChangeAuto = (e, val, name) => {
        switch (name) {
            case 'departmentName':
                setdepartmentName(val);
                break

        }
    }

    const onChangeHandler = (e, name) => {
        let value = e.target.value
        switch (name) {
            case 'categoryName':
                if (value === "" || value.length <= 50) {
                    setcategoryName(value)
                }
                break
        }
    }

    const textBox = (label, name, val, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    value={val ? val : ""}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const autoComplete = (label, name, val, list, width) => {
        const isMulti = name === 'departmentName' && !EditID
        return (
            <Box>
                <Autocomplete
                    multiple={isMulti}
                    limitTags={isMulti ? 1 : undefined}
                    size={'small'}
                    options={list}
                    name={name}
                    getOptionLabel={(option) => name === 'departmentName' ? `${option.department_name}` : option}
                    value={val}
                    onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                    renderInput={(params) => <TextField {...params} label={label} sx={{ width: width, marginRight: '0.3vw' }} />}
                />
            </Box>
        )
    }

    const TableHeaderBtns = () => {
        return (
            <Box>
                <Tooltip title="Filter" placement='top' arrow>
                    <IconButton size='small' onClick={() => { setFilterOpen(true) }}><FilterAltIcon color='primary' /></IconButton>
                </Tooltip>
            </Box>
        )
    }

    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText fromStore={true} isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} renderComponent={TableHeaderBtns} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = vendorList.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        vendorList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'category_code', headerName: 'Category Code', flex: 0.2,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.category_code ? params?.row?.category_code : '-'}</Box>)

            },
            {
                field: 'category_name', headerName: 'Category Name', flex: 0.6,
                renderCell: (params) => (params.row.category_name ? params.row.category_name?.length > 50 ?
                    <Tooltip placement="top" title={params.row.category_name}><Typography fontSize={'0.9vw'}>{params.row.category_name?.slice(0, 50) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.category_name}</Typography> : '-')

            },
            {
                field: 'department_name', headerName: 'Department Name', flex: 0.4,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.department_name ? ContentInTooltip(params?.row?.department_name, 30) : '-'}</Box>)

            },
            {
                field: 'is_active', headerName: 'Status', flex: 0.1,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.is_active ? "Active" : 'InActive'}</Box>)
            },
            {
                field: 'action', headerName: 'Action', flex: 0.1,
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw"
                                disable={delIDs?.length > 0}
                                onClick={() => {
                                    setcategoryName(params.row.category_name ? params.row.category_name : "");
                                    setcategoryCode(params.row.category_code ? params.row.category_code : "");
                                    setdepartmentName(departmentList?.find((list) => list?.id === params.row.department_id) || null)
                                    setIsActive(params.row.is_active)
                                    setEditID(params.row.id)
                                }} />
                        </Stack>
                    </Stack>)

            },
        ]
        return (
            <Box sx={{ height: '61vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={vendorList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const clearFunction = () => {
        setcategoryCode('');
        setcategoryName('');
        setdepartmentName([])
        setFilterOpen(false);
        setisDelete(false);
        setIsActive(true);
        setCheckBoxList([])
        setdelIDs([])
        setEditID(null)
    }

    const addCategoryendorDetails = () => {
        try {
            if (!categoryName) {
                errorMessage('Please Enter Category Name')
            } else if (EditID ? !departmentName?.id : !departmentName?.length) {
                // Edit: single object must have id | Create: array must have at least one
                errorMessage('Please Select Department Name')
            } else {
                if (EditID) {
                    // EDIT — single department, single row update
                    let data = {
                        id: EditID,
                        department_id: departmentName?.id,
                        category_name: categoryName,
                        is_active: isActive,
                    }
                    RestAPIService.updateWithOutId(data, Serviceurls.STORE_CATEGORY)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                successMessage(response.data.message)
                                clearFunction()
                                getCategoryDetails()
                            }
                        }).catch(e => {
                            setisloader(false)
                            if (e?.response?.data?.status === 'fail') {
                                errorMessage(e.response.data.message)
                            } else {
                                errorMessage(e.message)
                            }
                        })
                } else {
                    // CREATE — send department_ids list; BE creates one row per department
                    let data = {
                        department_ids: departmentName.map((dept) => dept.id),
                        category_name: categoryName,
                        is_active: isActive,
                    }
                    RestAPIService.create(data, Serviceurls.STORE_CATEGORY)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                successMessage(response.data.message)
                                clearFunction()
                                getCategoryDetails()
                            }
                        }).catch(e => {
                            setisloader(false)
                            if (e?.response?.data?.status === 'fail') {
                                errorMessage(e.response.data.message)
                            } else {
                                errorMessage(e.message)
                            }
                        })
                }
            }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const deleteVendor = () => {
        try {
            RestAPIService.delete(`${Serviceurls.STORE_CATEGORY}?ids=${delIDs || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getCategoryDetails()
                        closeFilter();
                        clearFunction()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={active_status}
                            getOptionLabel={(option) => option?.label}
                            value={filterActiveStatus}
                            onChange={(event, newValue) => {
                                setFilterActiveStatus(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Active Status'}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={departmentList}
                            getOptionLabel={(option) => option?.department_name}
                            value={filterdepartmentName}
                            onChange={(event, newValue) => {
                                setFilterdepartmentName(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Department'}
                                />
                            )}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            setFilterdepartmentName(null)
                            setFilterActiveStatus({ label: "All", value: "" })
                        }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            getCategoryDetails();
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ minHeight: '15.5vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', position: 'relative' }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                        {textBox("Category Code", 'categoryName', categoryCode, '20vw', true)}
                        {textBox("Category Name *", 'categoryName', categoryName, '20vw')}
                        {autoComplete("Department Name *", 'departmentName', departmentName, departmentList, '17vw')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' disabled={!EditID} />} label={"Active"} />
                    </Box>
                    <Box sx={{ gap: '1vw' }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { clearFunction() }}>Clear</Button>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} onClick={() => { addCategoryendorDetails() }}>{EditID ? "Update" : "Add"}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '61vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this category ?`}
                    AlertNote={"If you remove this category, the associated products, subcategories, and vendor mapping will also be deleted."}
                    deleteAlertPopupClose={closeFilter.bind(this)}
                    removeData={deleteVendor.bind(this)}
                />
                : null}
        </Box>
    )
}
